module.exports = __webpack_public_path__ + "img/tlc-dub.63c8221b.jpg";